module.exports = __webpack_public_path__ + "static/media/Logo_Recintes_Dotze_de_juny.5379de4c.png";